import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component } from "@eastsideco/salvo-ts";


import './LoadingSpinner.scss';

/**
 * ----------------------------------------------------------------------------
 * Component: LoadingSpinner
 * ------------------------------------------------------------------------------
 */
@Component
export class LoadingSpinner extends ThemeComponent  {

}
